interface FilterData {
  type: string;
  keyword: string;
}

class Filter {
  private cards: NodeListOf<HTMLElement>;
  private filters: NodeListOf<HTMLButtonElement>;
  private search: HTMLInputElement;
  private filtersData: FilterData = { type: '', keyword: '' };

  constructor() {
    this.cards = document.querySelectorAll('.js-workhours-cards');
    this.filters = document.querySelectorAll('.js-workhours-type');
    this.search = document.querySelector('.js-workhours-search');

    this.init();
    this.filterCards();
  }

  private init(): void {
    const defaultActiveFilter: HTMLButtonElement = document.querySelector(
      '.js-workhours-type.isActive'
    );
    if (defaultActiveFilter)
      this.filtersData.type = defaultActiveFilter.dataset.type;

    this.setupEvents();
  }

  private setupEvents(): void {
    if (this.filters && this.filters.length) {
      this.filters.forEach(filterButton =>
        filterButton.addEventListener('click', this.onFilterClick.bind(this))
      );
    }

    if (this.search) {
      this.search.addEventListener('keyup', this.onSearch.bind(this));
    }
  }

  private onFilterClick(e: Event): void {
    const el = e.target as HTMLButtonElement;
    this.filters.forEach(btn => btn.classList.remove('isActive'));
    el.classList.add('isActive');
    const { type } = el.dataset;
    this.filtersData.type = type;
    this.filterCards();
  }

  private onSearch(e: Event): void {
    const { value } = e.target as HTMLInputElement;
    this.filtersData.keyword = value.trim().toLowerCase();
    this.filterCards();
  }

  private filterCards(): void {
    this.cards.forEach(card => {
      const { types, searchKeywords } = card.dataset;
      if (
        types.includes(this.filtersData.type) &&
        searchKeywords.toLowerCase().includes(this.filtersData.keyword)
      ) {
        card.classList.remove('hidden');
      } else {
        card.classList.add('hidden');
      }
    });
  }
}

export default Filter;
